'use client';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import type { ImageData } from '@/types/shared';
import styles from './styles/styles.module.scss';

type ImageGalleryProps = {
  title: string;
  imgData: ImageData[];
};

const PostGallery = ({ title, imgData }: ImageGalleryProps) => {
  const intl = useIntl();

  const desktopImageCaption = (imageIndex: number, caption?: string) => {
    if (!caption) {
      return '';
    }
    if (imageIndex === 0) {
      return intl.formatMessage({ defaultMessage: 'Image left: {caption}' }, { caption });
    } else if (imageIndex === imgData.length - 1) {
      return intl.formatMessage({ defaultMessage: 'Image right: {caption}' }, { caption });
    } else {
      return intl.formatMessage({ defaultMessage: 'Image center: {caption}' }, { caption });
    }
  };

  const desktopCaption = imgData
    .filter(imgData => !!imgData.caption)
    .map((imgData, index) => desktopImageCaption(index, imgData.caption))
    .join(', ');

  return (
    <div>
      <div className={styles.galleryWrapper}>
        {imgData.map(imgData => (
          <div className={styles.imageAndCaptionWrapper} key={imgData.src}>
            <div className={styles.imageWrapper}>
              <Image src={imgData.src} alt={imgData.caption || title} loading="lazy" fill className={styles.image} aria-label={imgData.caption} />
            </div>
            {imgData.caption && <div className={classNames(styles.caption, styles.mobileCaption)}>{imgData.caption}</div>}
          </div>
        ))}
      </div>
      <div className={classNames(styles.caption, styles.desktopCaption)}>{desktopCaption}</div>
    </div>
  );
};

export default PostGallery;
